import React from 'react';

const RefundCancellationPolicy = () => {
    return (
        <div className="bg-gray-100 min-h-screen flex items-center justify-center">
            <div className="max-w-3xl bg-white rounded-lg shadow-lg p-8">
                <h1 className="text-3xl font-semibold mb-6 text-center">Refund and Cancellation Policy</h1>
                <div className="text-gray-800">
                    <p className="mb-4">
                        Our refund and cancellation policy for gated community maintenance dues and online payments is as follows:
                    </p>
                    <p className="mb-4">
                        <strong>Cancellation:</strong> Residents have the option to cancel their monthly maintenance dues payment
                        up until the specified due date. Once the due date has passed, the payment is considered final and non-refundable.
                    </p>
                    <p className="mb-4">
                        <strong>Refund:</strong> In the event that a resident accidentally makes a duplicate payment or encounters an overcharge,
                        we will issue a refund for the excess amount. Refund requests must be submitted within 7 days of the transaction.
                    </p>
                    <p className="mb-4">
                        <strong>Process:</strong> To request a refund or cancellation, please contact our community management team via email or phone.
                        Provide the transaction details, including payment date and amount, along with the reason for your request.
                    </p>
                    <p>
                        We are committed to providing transparent and efficient refund and cancellation processes for our residents.
                        If you have any questions or concerns, please feel free to reach out to our customer support.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default RefundCancellationPolicy;
